(() => {
  const choices=document.querySelector('[data-upgrade-choices]');
  if(!choices)return;
  let busy=false;
  choices.addEventListener('click',async event=>{
    const button=event.target.closest('[data-upgrade-variant]');
    if(!button||busy)return;
    busy=true;
    const error=choices.querySelector('[data-upgrade-error]');
    error.hidden=true;
    choices.querySelectorAll('button').forEach(b=>b.disabled=true);
    try {
      const response=await fetch(choices.dataset.updateUrl+'/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:{[choices.dataset.oldKey]:0,[button.dataset.upgradeVariant]:1}})});
      const result=await response.json();
      if(!response.ok)throw new Error(typeof result.description==='string'?result.description:choices.dataset.error);
      location.reload();
    } catch(e) {
      error.textContent=e.message||choices.dataset.error;
      error.hidden=false;
      busy=false;
      choices.querySelectorAll('button').forEach(b=>b.disabled=false);
    }
  });
})();
